import { useApi } from "@shopexperts/shared";
import { useQuery } from "@tanstack/vue-query";
import { computed, type Ref } from "vue";

/**
 * Loads a single badge by id so an already-saved selection can be displayed
 * even when the badge is not part of the current search results.
 */
export function useBadge(badgeId: Ref<number | null>) {
  const api = useApi();

  const {
    data: badge,
    isLoading,
    error,
  } = useQuery({
    queryKey: computed(() => ['admin', 'badge', badgeId.value]),
    queryFn: async () => {
      return await api.admin.badges.getBadge({
        params: { badge: badgeId.value! },
      });
    },
    enabled: computed(() => Boolean(badgeId.value)),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return { badge, isLoading, error };
}

export default useBadge;
